export const VERSION_EVENTS = {
  VERSION_STALE: "zamzi:version-stale",
  SERVER_ACTION_MISSING: "zamzi:server-action-missing",
  BEFORE_REFRESH: "zamzi:before-refresh",
} as const;

export const VERSION_REFRESH_COPY = {
  title: "We've just polished the engine!",
  description:
    "We've pushed a fresh update to Zamzi Connect to keep your booking system running at 100%. Please click Refresh to stay in sync - don't worry, we've saved your progress!",
};
